import { Editor } from 'slate';

export default function getFirstNode(editor, options) {
  const generator = Editor.nodes(editor, { ...options });
  const { value: nodeEntry, done } = generator.next();
  return done ? null : nodeEntry;
}
